export const environment = {
  production: false,
  urlCore: 'https://preiainaemp.apli.aragon.es/api',
  urlLogin: 'https://preiainaemp.apli.aragon.es',

  securityEnabled: true,
  oidc: {
    authority: 'https://pressob.aragon.es/mem/auth/iainaemp',
    clientId: 'iainaemp',
    scope: 'openid',
    responseType: 'code',
  },
};
